module.exports = __webpack_public_path__ + "media/audio3.becbc4e9.mp3";